
















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({
  components: {},
})
export default class FilterDropdown<T> extends Vue {
  // Props
  @Prop()
  public pageFilters!: any

  @Prop()
  public filedFilter?: string

  @Prop()
  public clearable?: boolean

  @Prop()
  public placeHolder?: string

  // Optional prop
  @Prop()
  public selected!: any

  @Prop()
  public filteredData!: T[]

  public handleSelect(option) {
    this.$emit('update:pageFilters', this.pageFilters)
    this.$emit('update:selected', option)
    this.$emit('onSelected', option)
  }
}
